import React from 'react';
import { useTranslation } from 'react-i18next';
import { Github, Linkedin, Mail, MessageCircle, ArrowUp } from 'lucide-react';

const socialLinks = [
  { name: 'GitHub', icon: Github, url: 'https://github.com/Anasaljammal' },
  { name: 'LinkedIn', icon: Linkedin, url: 'https://www.linkedin.com/in/anas-aljammal-47a512226' },
  { name: 'WhatsApp', icon: MessageCircle, url: 'https://wa.me/963997270886' },
  { name: 'Email', icon: Mail, url: 'mailto:anasaljammal686@gmail.com' },
];

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const quickLinks = [
    { name: t('footer.links.home'), href: '#home' },
    { name: t('footer.links.about'), href: '#about' },
    { name: t('footer.links.projects'), href: '#projects' },
    { name: t('footer.links.contact'), href: '#contact' },
  ];

  return (
    <footer className="border-t border-hairline">
      <div className="container-page py-16">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          <div className="lg:col-span-2">
            <p className="ui text-[15px] font-semibold tracking-[0.06em] text-ink">Anas Jammal</p>
            <p className="mt-4 max-w-xs text-[15px] leading-relaxed text-graphite">
              {t('footer.description')}
            </p>
          </div>

          <nav aria-label="Footer">
            <h2 className="ui text-[12px] font-semibold uppercase tracking-[0.16em] text-graphite">
              {t('footer.linksTitle')}
            </h2>
            <ul className="mt-4">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="ui link-quiet flex min-h-[44px] items-center text-[15px]"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h2 className="ui text-[12px] font-semibold uppercase tracking-[0.16em] text-graphite">
              {t('footer.social')}
            </h2>
            <ul className="mt-4">
              {socialLinks.map((social) => (
                <li key={social.name}>
                  <a
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ui link-quiet flex min-h-[44px] items-center gap-2.5 text-[15px]"
                  >
                    <social.icon size={16} aria-hidden="true" />
                    {social.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-hairline pt-8 sm:flex-row sm:items-center">
          <p className="ui text-[14px] text-graphite">
            © {year} Anas Jammal. {t('footer.copyright')}.
          </p>
          <a
            href="#home"
            className="ui link-quiet inline-flex min-h-[44px] items-center gap-2 text-[14px]"
          >
            {t('footer.backToTop')}
            <ArrowUp size={15} aria-hidden="true" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
